import i18n from 'i18n/config';
import Footer from 'modules/_shared/components/Footer';
import MaintenanceImage from 'assets/images/sttok_maintenance.png';

import '../../../../App.scss';
import '../../../../assets/styles/Bootstrap.scss';
import '../../../../assets/styles/Components.scss';
import '../../../../assets/styles/Fonts.scss';
import '../../../../assets/styles/Icons.scss';
import '../../../../assets/styles/Layouts.scss';
import '../../../../assets/styles/Misc.scss';
import '../../../../assets/styles/Placeholder.scss';
import '../../../../assets/styles/Print.scss';
import '../../../../assets/styles/ReactSelect.scss';
import '../../../../assets/styles/Stepper.scss';
import '../../../../assets/styles/Styles.scss';
import '../../../../assets/styles/Timeline.scss';
import '../../../../assets/styles/Animation.scss';

const UnderMaintenance = () => (
  <div
    className="nk-body npc-default has-aside no-touch nk-nio-theme"
    id="under-maintenance-page"
  >
    <div className="nk-app-root">
      <div className="nk-main ">
        <div className="nk-wrap nk-wrap-nosidebar bg-white">
          <div className="nk-content">
            <div className="nk-block-middle wide-md mx-auto">
              <div className="nk-error-ld text-center">
                <img
                  className="nk-error-gfx"
                  src={MaintenanceImage}
                  alt="error"
                />
                <div className="wide-xs mx-auto">
                  <h3 className="nk-error-title">
                    {i18n.t('UnderMaintenanceTitle')}
                  </h3>
                  <p className="nk-error-text">
                    {i18n.t('UnderMaintenanceMessage')}
                  </p>
                  <p className="nk-error-text">
                    {i18n.t('UnderMaintenanceContactPart1')}
                    <a
                      href="mailto:info@sttok.com"
                      className="link link-primary fs-16px"
                      style={{ fontSize: '16px' }}
                    >
                      info@sttok.com
                    </a>
                    {i18n.t('UnderMaintenanceContactPart2')}
                    <a
                      href="tel:+34607838348"
                      className="link link-primary fs-16px"
                      style={{ fontSize: '16px' }}
                    >
                      +34 607 83 83 48
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default UnderMaintenance;
